export const Types = {
  RESET_DATA_STOCK_MOVEMENT: "stockMovement/RESET_DATA",

  CHANGE_STOCK_MOVEMENT_PAGINATION: "stockMovement/CHANGE_PAGINATION",

  GET_STOCK_MOVEMENT_INDEX: "stockMovement/GET_INDEX",
  GET_STOCK_MOVEMENT_INDEX_SUCCESS: "stockMovement/GET_INDEX_SUCCESS",
  GET_STOCK_MOVEMENT_INDEX_ERROR: "stockMovement/GET_INDEX_ERROR",

  GET_STOCK_MOVEMENT_SHOW: "stockMovement/GET_SHOW",
  GET_STOCK_MOVEMENT_SHOW_SUCCESS: "stockMovement/GET_SHOW_SUCCESS",
  GET_STOCK_MOVEMENT_SHOW_ERROR: "stockMovement/GET_SHOW_ERROR",

  SAVE_STOCK_MOVEMENT: "stockMovement/SAVE",
  SAVE_STOCK_MOVEMENT_SUCCESS: "stockMovement/SAVE_SUCCESS",
  SAVE_STOCK_MOVEMENT_ERROR: "stockMovement/SAVE_ERROR",

  REQUEST_DELETE_STOCK_MOVEMENT: "stockMovement/REQUEST_DELETE",
  REQUEST_DELETE_STOCK_MOVEMENT_SUCCESS: "stockMovement/REQUEST_DELETE_SUCCESS",
  REQUEST_DELETE_STOCK_MOVEMENT_ERROR: "stockMovement/REQUEST_DELETE_ERROR",

  SHOW_DRAWER_STOCK_MOVEMENT: "stockMovement/SHOW_DRAWER",
  HIDE_DRAWER_STOCK_MOVEMENT: "stockMovement/HIDE_DRAWER",

  SHOW_MODAL_NEW_STOCK_MOVEMENT: "stockMovement/SHOW_MODAL_NEW",
  HIDE_MODAL_NEW_STOCK_MOVEMENT: "stockMovement/HIDE_MODAL_NEW",
};

export const Creators = {
  changeStockMovementPagination: (page, size) => ({
    type: Types.CHANGE_STOCK_MOVEMENT_PAGINATION,
    payload: { page, size },
  }),
  indexStockMovement: (
    groupId,
    farmId,
    page = 0,
    size = 15,
    sorter = {},
    filters = "",
  ) => ({
    type: Types.GET_STOCK_MOVEMENT_INDEX,
    payload: { groupId, farmId, page, size, sorter, filters },
  }),
  indexStockMovementSuccess: (data, pagination) => ({
    type: Types.GET_STOCK_MOVEMENT_INDEX_SUCCESS,
    payload: { data, pagination },
  }),
  indexStockMovementError: (error) => ({
    type: Types.GET_STOCK_MOVEMENT_INDEX_ERROR,
    payload: { error },
  }),

  showStockMovement: (groupId, farmId, id) => ({
    type: Types.GET_STOCK_MOVEMENT_SHOW,
    payload: { groupId, farmId, id },
  }),
  showStockMovementSuccess: (data) => ({
    type: Types.GET_STOCK_MOVEMENT_SHOW_SUCCESS,
    payload: { data },
  }),
  showStockMovementError: (error) => ({
    type: Types.GET_STOCK_MOVEMENT_SHOW_ERROR,
    payload: { error },
  }),

  // Movimento é imutável: só cria (sem edição). O backend define o status.
  saveStockMovement: (groupId, farmId, movement) => ({
    type: Types.SAVE_STOCK_MOVEMENT,
    payload: { groupId, farmId, movement },
  }),
  saveStockMovementSuccess: () => ({
    type: Types.SAVE_STOCK_MOVEMENT_SUCCESS,
    payload: {},
  }),
  saveStockMovementError: (error) => ({
    type: Types.SAVE_STOCK_MOVEMENT_ERROR,
    payload: { error },
  }),

  // Exclusão não é direta: vai para auditoria (status AUDIT).
  requestDeleteStockMovement: (groupId, farmId, id, requestUser) => ({
    type: Types.REQUEST_DELETE_STOCK_MOVEMENT,
    payload: { groupId, farmId, id, requestUser },
  }),
  requestDeleteStockMovementSuccess: () => ({
    type: Types.REQUEST_DELETE_STOCK_MOVEMENT_SUCCESS,
    payload: {},
  }),
  requestDeleteStockMovementError: (error) => ({
    type: Types.REQUEST_DELETE_STOCK_MOVEMENT_ERROR,
    payload: { error },
  }),

  showDrawerStockMovement: () => ({
    type: Types.SHOW_DRAWER_STOCK_MOVEMENT,
    payload: {},
  }),
  hideDrawerStockMovement: () => ({
    type: Types.HIDE_DRAWER_STOCK_MOVEMENT,
    payload: {},
  }),

  // type: 'ENTRY' | 'EXIT' — define o tipo do movimento que será criado.
  showModalNewStockMovement: (type = "ENTRY") => ({
    type: Types.SHOW_MODAL_NEW_STOCK_MOVEMENT,
    payload: { newMovementType: type },
  }),
  hideModalNewStockMovement: () => ({
    type: Types.HIDE_MODAL_NEW_STOCK_MOVEMENT,
    payload: {},
  }),

  resetDataStockMovement: () => ({
    type: Types.RESET_DATA_STOCK_MOVEMENT,
    payload: {},
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  isLoadingEdit: false,
  data: [],
  dataMovement: null,
  pagination: { total: 0, size: 15, page: 0, sorter: {}, filters: "" },
  isModalVisible: false,
  isDrawerVisible: false,
  newMovementType: "ENTRY",
  error: null,
};

export default function stockMovement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA_STOCK_MOVEMENT:
      return INITIAL_STATE;

    case Types.CHANGE_STOCK_MOVEMENT_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload.page,
          size: action.payload.size,
        },
      };

    case Types.GET_STOCK_MOVEMENT_INDEX:
      return { ...state, isLoading: true };
    case Types.GET_STOCK_MOVEMENT_INDEX_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case Types.GET_STOCK_MOVEMENT_INDEX_ERROR:
      return { ...state, isLoading: false, error: action.payload.error };

    case Types.GET_STOCK_MOVEMENT_SHOW:
      return { ...state, isLoadingEdit: true };
    case Types.GET_STOCK_MOVEMENT_SHOW_SUCCESS:
      return {
        ...state,
        isLoadingEdit: false,
        dataMovement: action.payload.data,
      };
    case Types.GET_STOCK_MOVEMENT_SHOW_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.SAVE_STOCK_MOVEMENT:
      return { ...state, isLoadingEdit: true };
    case Types.SAVE_STOCK_MOVEMENT_SUCCESS:
      return { ...state, isLoadingEdit: false, isModalVisible: false };
    case Types.SAVE_STOCK_MOVEMENT_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.REQUEST_DELETE_STOCK_MOVEMENT:
      return { ...state, isLoadingEdit: true };
    case Types.REQUEST_DELETE_STOCK_MOVEMENT_SUCCESS:
      return {
        ...state,
        isLoadingEdit: false,
        isDrawerVisible: false,
        dataMovement: null,
      };
    case Types.REQUEST_DELETE_STOCK_MOVEMENT_ERROR:
      return { ...state, isLoadingEdit: false, error: action.payload.error };

    case Types.SHOW_DRAWER_STOCK_MOVEMENT:
      return { ...state, isDrawerVisible: true };
    case Types.HIDE_DRAWER_STOCK_MOVEMENT:
      return { ...state, isDrawerVisible: false, dataMovement: null };

    case Types.SHOW_MODAL_NEW_STOCK_MOVEMENT:
      return {
        ...state,
        isModalVisible: true,
        newMovementType: action.payload.newMovementType,
      };
    case Types.HIDE_MODAL_NEW_STOCK_MOVEMENT:
      return { ...state, isModalVisible: false };

    default:
      return state;
  }
}
